import React from 'react';
import styles from './Card.module.css';
import { useNavigate } from 'react-router-dom';


export function Card({ title, location, image, navigateURL }) {
  const navigate = useNavigate()
  return (
    <div className={styles.card} onClick={()=>{navigate(navigateURL)}}>
      <img
        src={image}
        alt={title}
        className={styles.image}
      />
      <div className={styles.overlay}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.location}>
          {/* <MapPin className={styles.icon} /> */}
          <span className={styles.locationText}>{location}</span>
        </div>
      </div>
    </div>
  );
}